export const columnsToExport = [
  'tipoCarga',
  'contenedor',
  'nombreExportador',
  'embarcador',
  'booking',
  'observaciones',
  'mercaderia',
  'destinoFinal',
  'tipo',
  'tamano',
  'temperatura',
  'ventilacion',
  'imos',
  'uns',
  'fecha',
  'precinto1',
  'precinto2',
  'precinto3',
  'precinto4',
  'mgw',
  'tara',
  'peso',
  'fechaPTI',
  'humedad',
  'o2',
  'cO2',
];
